import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useState } from "react";
import { doc, getDoc, writeBatch } from "firebase/firestore";
import { useDispatch } from "@root/store";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { SET_REQUESTING_STATUS, SIGNIN_FAIL, SIGNIN_SUCCESS, SIGNIN_REQUEST, OPEN_DIALOG, CLOSE_DIALOG, CREATE_USER_FAIL, CREATE_USER_SUCCESS, CREATE_CLEAR_ERROR, LOG_OUT } from "./types";
import { closeModal, openSimpleModal } from "../modal/actions";
import { database, profiles, usernames } from "../../config/firestore";
import { createUserWithEmailAndPassword, getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { isEmpty } from "lodash";
import { push } from "connected-react-router";
import { openSnackbar } from "../snackbar/actions";
import { SnackbarType } from "../snackbar/types";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var login = function login(email, password) {
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(dispatch) {
            var user;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({
                                type: SIGNIN_REQUEST
                            });
                            _context.prev = 1;
                            _context.next = 4;
                            return signInWithEmailAndPassword(getAuth(), email, password);
                        case 4:
                            user = _context.sent;
                            dispatch({
                                type: SIGNIN_SUCCESS,
                                user: user
                            });
                            _context.next = 11;
                            break;
                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](1);
                            dispatch({
                                type: SIGNIN_FAIL
                            });
                        case 11:
                        case "end":
                            return _context.stop();
                    }
            }, _callee, null, [[1, 8]]);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
// const profileFinalize = (
//     user: { displayName: string | undefined; uid: string },
//     dispatch: (any) => void
// ): (() => React.ReactElement) => {
//     return
// };
export function ProfileFinalize(_ref2) {
    var user = _ref2.user;
    var dispatch = useDispatch();
    var _useState = useState(""), _useState2 = _slicedToArray(_useState, 2), input = _useState2[0], setInput = _useState2[1];
    var _useState3 = useState(user.displayName || ""), _useState4 = _slicedToArray(_useState3, 2), displayName = _useState4[0], setDisplayName = _useState4[1];
    var _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), nameReserved = _useState6[0], setNameReserved = _useState6[1];
    var _useState7 = useState(""), _useState8 = _slicedToArray(_useState7, 2), bio = _useState8[0], setBio = _useState8[1];
    var _useState9 = useState(""), _useState10 = _slicedToArray(_useState9, 2), link1 = _useState10[0], setLink1 = _useState10[1];
    var _useState11 = useState(""), _useState12 = _slicedToArray(_useState11, 2), link2 = _useState12[0], setLink2 = _useState12[1];
    var _useState13 = useState(""), _useState14 = _slicedToArray(_useState13, 2), link3 = _useState14[0], setLink3 = _useState14[1];
    var checkReservedUsername = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(candidate) {
            var document_;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return getDoc(doc(usernames, candidate));
                        case 2:
                            document_ = _context2.sent;
                            setNameReserved(document_.exists());
                        case 4:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2);
        }));
        return function checkReservedUsername(_x2) {
            return _ref3.apply(this, arguments);
        };
    }();
    var shouldDisable = isEmpty(input) || !/^[\dA-Za-z]+$/.test(input);
    var handleOnSubmit = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3() {
        var batch, usernameReference, profileReference;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1)
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (nameReserved) {
                            _context3.next = 17;
                            break;
                        }
                        batch = writeBatch(database);
                        usernameReference = doc(usernames, input);
                        profileReference = doc(profiles, user.uid);
                        batch.set(usernameReference, {
                            userUid: user.uid
                        }, {
                            merge: true
                        });
                        batch.set(profileReference, {
                            username: input,
                            displayName: displayName,
                            bio: bio,
                            link1: link1,
                            link2: link2,
                            link3: link3
                        }, {
                            merge: true
                        });
                        _context3.prev = 6;
                        _context3.next = 9;
                        return batch.commit();
                    case 9:
                        dispatch(closeModal());
                        dispatch(openSnackbar("Profile created!", SnackbarType.Success));
                        dispatch({
                            type: SIGNIN_SUCCESS,
                            user: user
                        });
                        _context3.next = 17;
                        break;
                    case 14:
                        _context3.prev = 14;
                        _context3.t0 = _context3["catch"](6);
                        dispatch(openSnackbar("Could not create profile: " + _context3.t0, SnackbarType.Error));
                    case 17:
                    case "end":
                        return _context3.stop();
                }
        }, _callee3, null, [[6, 14]]);
    })), [dispatch, nameReserved, input, bio, displayName, link1, link2, link3, user]);
    var textFieldStyle = {
        marginBottom: 12
    };
    return ___EmotionJSX("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, ___EmotionJSX("h2", null, "Almost there..."), ___EmotionJSX("p", null, "Please choose a unique username and tell us something about you (if you want to).", ___EmotionJSX("br", null), "You can change this data at anytime, except for your username, so choose it carefully."), ___EmotionJSX(TextField, {
        style: textFieldStyle,
        label: nameReserved ? input + " already exists!" : "New username",
        onChange: function onChange(event) {
            event.target.value.length < 50 && setInput(event.target.value);
            event.target.value.length < 50 && !isEmpty(event.target.value) && checkReservedUsername(event.target.value);
        },
        error: shouldDisable || nameReserved,
        value: input
    }), ___EmotionJSX(TextField, {
        style: textFieldStyle,
        label: "Full name (your display name)",
        value: displayName || "",
        onChange: function onChange(event) {
            event.target.value.length < 50 && setDisplayName(event.target.value || "");
        }
    }), ___EmotionJSX(TextField, {
        style: textFieldStyle,
        label: "Composer/Artist/Faculty homepage URL",
        value: link1 || "",
        onChange: function onChange(event) {
            setLink1(event.target.value || "");
        }
    }), ___EmotionJSX(TextField, {
        style: textFieldStyle,
        label: "Optional social media URL",
        value: link2 || "",
        onChange: function onChange(event) {
            setLink2(event.target.value || "");
        }
    }), ___EmotionJSX(TextField, {
        style: textFieldStyle,
        label: "Optional social media URL",
        value: link3 || "",
        onChange: function onChange(event) {
            setLink3(event.target.value || "");
        }
    }), ___EmotionJSX(TextField, {
        style: textFieldStyle,
        label: "Bio",
        value: bio || "",
        onChange: function onChange(event) {
            setBio(event.target.value || "");
        },
        minRows: 4,
        multiline: true
    }), ___EmotionJSX(Button, {
        variant: "outlined",
        color: "primary",
        disabled: shouldDisable || nameReserved,
        onClick: handleOnSubmit,
        style: {
            marginTop: 11
        }
    }, "Create Profile"));
}
export var thirdPartyAuthSuccess = function thirdPartyAuthSuccess(user, fromAutoLogin) {
    return /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(dispatch) {
            var profile, profileData;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return getDoc(doc(profiles, user.uid));
                        case 3:
                            profile = _context4.sent;
                            _context4.next = 10;
                            break;
                        case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4["catch"](0);
                            if (_context4.t0.name === "FirebaseError" && _context4.t0.code === "unavailable") {
                                dispatch(openSnackbar("Network error: offline", SnackbarType.Error, 5 * 60 * 1000));
                            }
                            return _context4.abrupt("return");
                        case 10:
                            if (profile !== undefined && (!profile.exists || profile.data() && isEmpty(profile.data().username))) {
                                dispatch(openSimpleModal("project-finalize", {
                                    user: user
                                }));
                            }
                            else {
                                profileData = profile.data();
                                dispatch({
                                    type: SIGNIN_SUCCESS,
                                    user: user
                                });
                                !fromAutoLogin && profileData && dispatch(push("/profile/".concat(profileData.username)));
                            }
                        case 11:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4, null, [[0, 6]]);
        }));
        return function (_x3) {
            return _ref5.apply(this, arguments);
        };
    }();
};
export var openLoginDialog = function openLoginDialog() {
    return /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(dispatch) {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1)
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({
                                type: OPEN_DIALOG
                            });
                        case 1:
                        case "end":
                            return _context5.stop();
                    }
            }, _callee5);
        }));
        return function (_x4) {
            return _ref6.apply(this, arguments);
        };
    }();
};
export var closeLoginDialog = function closeLoginDialog() {
    return /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(dispatch) {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1)
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({
                                type: CLOSE_DIALOG
                            });
                        case 1:
                        case "end":
                            return _context6.stop();
                    }
            }, _callee6);
        }));
        return function (_x5) {
            return _ref7.apply(this, arguments);
        };
    }();
};
export var logOut = function logOut() {
    return /*#__PURE__*/ function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(dispatch) {
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1)
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.prev = 0;
                            _context7.next = 3;
                            return getAuth().signOut();
                        case 3:
                            _context7.next = 8;
                            break;
                        case 5:
                            _context7.prev = 5;
                            _context7.t0 = _context7["catch"](0);
                            console.error(_context7.t0);
                        case 8:
                            dispatch(push("/"));
                            dispatch({
                                type: LOG_OUT
                            });
                        case 10:
                        case "end":
                            return _context7.stop();
                    }
            }, _callee7, null, [[0, 5]]);
        }));
        return function (_x6) {
            return _ref8.apply(this, arguments);
        };
    }();
};
export var createNewUser = function createNewUser(email, password) {
    return /*#__PURE__*/ function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8(dispatch) {
            var credentials;
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1)
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.prev = 0;
                            _context8.next = 3;
                            return createUserWithEmailAndPassword(getAuth(), email, password);
                        case 3:
                            credentials = _context8.sent;
                            dispatch({
                                type: CREATE_USER_SUCCESS,
                                credentials: credentials
                            });
                            _context8.next = 10;
                            break;
                        case 7:
                            _context8.prev = 7;
                            _context8.t0 = _context8["catch"](0);
                            dispatch({
                                type: CREATE_USER_FAIL,
                                errorCode: _context8.t0.code,
                                errorMessage: _context8.t0.message
                            });
                        case 10:
                        case "end":
                            return _context8.stop();
                    }
            }, _callee8, null, [[0, 7]]);
        }));
        return function (_x7) {
            return _ref9.apply(this, arguments);
        };
    }();
};
export var createUserClearError = function createUserClearError() {
    return /*#__PURE__*/ function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9(dispatch) {
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1)
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({
                                type: CREATE_CLEAR_ERROR
                            });
                        case 1:
                        case "end":
                            return _context9.stop();
                    }
            }, _callee9);
        }));
        return function (_x8) {
            return _ref10.apply(this, arguments);
        };
    }();
};
export var setRequestingStatus = function setRequestingStatus(status) {
    return /*#__PURE__*/ function () {
        var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(dispatch) {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1)
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({
                                type: SET_REQUESTING_STATUS,
                                status: status
                            });
                        case 1:
                        case "end":
                            return _context10.stop();
                    }
            }, _callee10);
        }));
        return function (_x9) {
            return _ref11.apply(this, arguments);
        };
    }();
};
export var resetPassword = function resetPassword(email) {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1)
                switch (_context11.prev = _context11.next) {
                    case 0:
                        _context11.next = 2;
                        return sendPasswordResetEmail(getAuth(), email);
                    case 2:
                    case "end":
                        return _context11.stop();
                }
        }, _callee11);
    }));
};
